exports.components = {
  "component---src-components-templates-register-template-jsx": () => import("./../../../src/components/templates/register-template.jsx" /* webpackChunkName: "component---src-components-templates-register-template-jsx" */),
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-autorizacion-acudiente-jsx": () => import("./../../../src/pages/autorizacion-acudiente.jsx" /* webpackChunkName: "component---src-pages-autorizacion-acudiente-jsx" */),
  "component---src-pages-index-jsx": () => import("./../../../src/pages/index.jsx" /* webpackChunkName: "component---src-pages-index-jsx" */)
}

